function SalahTimings() {
   return (
    
      <div className="page-container">
          <h1 className="page-title">Salah Timings</h1>

          <div className="page-content">
            <p>
            To be updated!
            </p>

          </div>
        </div>

  );
}
export default SalahTimings;